module.exports = __webpack_public_path__ + "static/media/trophy-icon.5fa370f4.svg";